export enum ApiRoutesWhatsAppAdProducts {
  AdProducts = "admin/whatsapp-bot/ad-products"
}

export enum AdProductSource {
  Manual = "manual",
  AdName = "ad_name"
}
